module.exports = __webpack_public_path__ + "img/t4-media-block.b2295c4a.png";